<template>
    <div>
        <Button style="border: none" :size="size" :type="type" @click="switchPopup">
            <div class="btn-content">
                <span>{{ text }}</span>
                <Icon :name="arrow"/>
            </div>
        </Button>
        <Popup position="bottom" v-model="show">
            <Picker
                    show-toolbar
                    :title="title"
                    :columns="data"
                    @confirm="onConfirm"
                    @cancel="switchPopup"
            />
        </Popup>
    </div>
</template>

<script>
import { Button, Icon, Picker, Popup } from "vant";

export default {
  props: {
    type: { type: String, default: "default" },
    data: { type: Array, required: true },
    title: { type: String, default: "请选择" },
    block: { type: Boolean, default: false },
    size: { type: String, default: "normal" }
  },
  components: {
    Button,
    Popup,
    Picker,
    Icon
  },
  data() {
    return {
      text: this.data[0].text,
      value: this.data[0].value,
      show: false,
      arrow: "arrow-down"
    };
  },
  methods: {
    switchPopup() {
      this.show = !this.show;
    },
    onConfirm(item) {
      this.text = item.text;
      this.value = item.value;
      this.show = false;
      this.$emit("ok", item);
    }
  },
  watch: {
    show(show) {
      if (show) {
        this.arrow = "arrow-up";
      } else {
        this.arrow = "arrow-down";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.btn-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
